import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { calculateFilterCount } from "../utils/utils";

type TabType = "EXPECTED" | "RELEASED" | "SETTLED" | "SEARCH";

const formatDate = (d: Date) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const today = new Date();
const oneMonthAgo = new Date();
oneMonthAgo.setMonth(today.getMonth() - 1);

const DEFAULT_DATE_RANGE = {
  from: formatDate(oneMonthAgo),
  to: formatDate(today),
};

const defaultCN = [{ cn: "With CN", value: "with" }];
const defaultShortage = [
  { shortage: "Without Shortage", label: "Without Shortage", value: "without" },
];

const createBaseFilters = () => ({
  company: undefined,
  stockist: undefined,
  division: undefined,
  product: undefined,
  filterCount: 0,
});

const createSearchFilters = () => ({
  company: undefined,
  stockist: undefined,
  filterCount: 0,
});

const createAdvancedFilters = () => {
  const filters = {
    company: undefined,
    stockist: undefined,
    division: undefined,
    product: undefined,
    cn: defaultCN,
    shortage: defaultShortage,
    dateRange: DEFAULT_DATE_RANGE,
    filterCount: 0,
  };

  filters.filterCount = calculateFilterCount(filters);

  return filters;
};

export interface SettlementState {
  filters: {
    EXPECTED: ReturnType<typeof createBaseFilters>;
    RELEASED: ReturnType<typeof createAdvancedFilters>;
    SETTLED: ReturnType<typeof createAdvancedFilters>;
    SEARCH: ReturnType<typeof createSearchFilters>;
  };
  settlementFiltersData: any;
  report_type: string;
}

const initialState: SettlementState = {
  filters: {
    EXPECTED: createBaseFilters(),
    RELEASED: createAdvancedFilters(),
    SETTLED: createAdvancedFilters(),
    SEARCH: createSearchFilters(),
  },
  settlementFiltersData: {},
  report_type: ""
};

const settlementSlice = createSlice({
  name: "settlement",
  initialState,
  reducers: {
    setFilter(
      state,
      action: PayloadAction<{
        tab: TabType;
        key: string;
        value: any;
      }>
    ) {
      const { tab, key, value } = action.payload;

      (state.filters[tab] as any)[key] = value;

      state.filters[tab].filterCount = calculateFilterCount(
        state.filters[tab]
      );
    },

    resetFilters(state, action: PayloadAction<TabType>) {
      const tab = action.payload;

      if (tab === "EXPECTED") state.filters[tab] = createBaseFilters();
      else if (tab === "SEARCH") state.filters[tab] = createSearchFilters();
      else state.filters[tab] = createAdvancedFilters();
    },

    setSettlementFiltersData(
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) {
      state.settlementFiltersData[action.payload.key] =
        action.payload.value;
    },

    setReportType(state, action: PayloadAction<string>) {
      state.report_type = action.payload;
    }
  },
});

export const settlementActions = settlementSlice.actions;
export { settlementSlice };
